module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__Skills"
  }, [_c('header'), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', [_c('h3', [_vm._v("Front-End：")]), _c('p', [_vm._v("【 Good 】： "), _c('span', [_vm._v("ES6、React、GSAP(GreenSock)、A-frame(WebVR)、Sass(SCSS)")])]), _c('p', [_vm._v("【 Competent 】： "), _c('span', [_vm._v("Vue.js、AngularJS(1)、Rx.js、Pug、Nightwatch、Chai、Sinon...")])]), _c('p', [_vm._v("【 Tool 】： "), _c('span', [_vm._v("Webpack、Gulp、Git、Mercurial(hg)、npm...")])]), _c('h3', [_vm._v("Back-End：")]), _c('p', [_vm._v("【 Competent 】： "), _c('span', [_vm._v("MongoDB(Mongoose)、Express、")])]), _c('p', [_vm._v("【 Limited 】："), _c('span', [_vm._v("php、MySQL、")])]), _c('h3', [_vm._v("Design：")]), _c('p', [_vm._v("【 Graphic 】："), _c('span', [_vm._v("Adobe Photoshop、Illustrator (Limited)、")])]), _c('p', [_vm._v("【 3D 】："), _c('span', [_vm._v("PTC Creo Elements/Direct、Pro/E、")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a2c5fcc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Skills/Skills.vue
// module id = 58
// module chunks = 0